export default {"src":"/_next/static/media/cart-add.d8e54bb5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};